import type { ButtonSize } from './types';

export const sizeClasses: Record<ButtonSize, string> = {
	small: 'text-mobile-label-medium lg:text-desktop-label-small',
	medium: 'text-mobile-paragraph-small lg:text-desktop-label-medium',
	large: 'text-mobile-label-large lg:text-desktop-label-large',
	'extra-large': 'text-mobile-label-large lg:text-desktop-label-large'
};

const paddings: Record<ButtonSize, { icon: number; x: number; y: number }> = {
	small: { x: 12, y: 9, icon: 8 },
	medium: { x: 16, y: 11.5, icon: 12 },
	large: { x: 24, y: 14.5, icon: 16 },
	'extra-large': { x: 32, y: 14.5, icon: 24 }
};

export function getPaddings(
	size: ButtonSize,
	iconLeading: boolean,
	iconTrailing: boolean
): { left: number; right: number; vertical: number } {
	const padding = paddings[size];
	if (!padding) {
		return { left: 0, right: 0, vertical: 0 };
	}

	if (iconLeading && iconTrailing) {
		return { left: padding.icon, right: padding.icon, vertical: padding.y };
	}

	if (iconLeading) {
		return { left: padding.icon, right: padding.x, vertical: padding.y };
	}

	if (iconTrailing) {
		return { left: padding.x, right: padding.icon, vertical: padding.y };
	}

	return { left: padding.x, right: padding.x, vertical: padding.y };
}
